// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M98h","clinicsSelect":"styles_clinicsSelect__zPEsY"};